<template>
  <router-view />
</template>

<script>
export default {
  name: 'GerenciamentoHome',
}
</script>
